import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'

import { Checkbox, Flex, Text } from 'components/ds'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import modalStyles from 'components/utils/modalStyles'

export type Props = {
  onConfirm: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  onHideWarningChange: (...args: Array<any>) => any
  hideWarning: boolean
}

const RemoveFromChannelDialog = (props: Props): React.ReactNode => {
  const { onConfirm, onCancel, hideWarning, onHideWarningChange } = props
  return (
    <Modal style={modalStyles} isOpen onRequestClose={onCancel}>
      <Theme>
        <div className="Dialog">
          <h1 className="Form_Header">Remove items</h1>
          <div>
            Are you sure you want to remove these items from your channel? This
            can&#39;t be undone.
          </div>
          <Flex gap="2" align="center" justify="between">
            <Text as="label" size="2">
              <Flex gap="2">
                <Checkbox
                  defaultChecked={hideWarning}
                  onCheckedChange={onHideWarningChange}
                />
                Don&#39;t show this warning again
              </Flex>
            </Text>
            <ButtonContainer>
              <Button caption="Cancel" onClick={onCancel} />
              <Button
                caption="Remove"
                onClick={onConfirm}
                appearance="primary"
              />
            </ButtonContainer>
          </Flex>
        </div>
      </Theme>
    </Modal>
  )
}

export default RemoveFromChannelDialog
